export default "__VITE_ASSET__B4EG0UTd__"